var racine = "/index.php";

(function($){
$(document).ready(function() {


    $(window).attr("isDirty", false);
    $(":input").bind("change", function(event) {
        if (event.target.value != event.target.defaultValue) {
            $(window).attr("isDirty", true);
        }
    });
    $(":checkbox,:radio").bind("click", function(event) {
        if (event.target.checked != event.target.defaultChecked) {
            $(window).attr("isDirty", true);
        }
    });

    $( '[data-ui="tooltip"]' ).tooltip();

    var $adminPanel = $(".adminPanel");
    $adminPanel.stickybits({ useStickyClasses: true });

    $('.adminClose').on("click", function(e) {
        e.preventDefault();
        if (!window.isDirty || confirm("Etes-vous sûr(e) de vouloir quitter cette page sans enregistrer ?"))
            window.location.href=$(this).data("url");
    })

    $('.mode_bloc').on("click", function(e) {
        e.preventDefault();
        $('body').toggleClass("mode_bloc");
        $(this).toggleClass("on");
        $(this).blur();
    })

    $( ".sortable-elts" ).sortable ( {
        accept : 'sortable_elt',
        axis : 'y',
        opacity : 0.6,
        activate: function( event, ui ) {
          if($(this).data('axis') == 'x') {
                $(this).sortable( "option", "axis", 'x');
              }
          else if($(this).data('axis') == 'xy') {
                $(this).sortable( "option", "axis", '');
              }
        },
        stop : function ( event, ui ) {
            var parameters = $(this).sortable( "serialize" ),
                action = $(this).data("action"),
                torefresh = $(this).data("torefresh"),
                sortedIDs = $(this).sortable( "toArray", {attribute : "id"});
            // requête Ajax pour l'enregistrement des positions
            $.ajax ( {
                url : "/inc/xhr/set_position.php?db=" + action + "&" + parameters,
                success: function(data){
                    console.log(data);
                    if (torefresh != "") {
                        for (a = 0; a < sortedIDs.length; a++){
                            id = sortedIDs[a].substr(3);
                            $("#"+torefresh+" #item_"+id).attr("data-position", (a+1));
                        }
                        $(function() {
                            $("#"+torefresh).html($("#"+torefresh+" > li").sort(sort_li));
                            function sort_li(a, b){
                                console.log($(b).data('position'));
                                return ($(b).data('position')) < ($(a).data('position')) ? 1 : -1;
                            }
                        });
                    }
                }
            });
        }
    });


    $(".listedates").on("click", ".supprimer-ligne", function(e){
        e.preventDefault();
        $(this).parent().parent().remove();
    });

    $(".ajouter-ligne").on("click", function(e){
        e.preventDefault();
        firstligne = $('.lignezero');
        lastligne = $('.lignedates').last();
        firstligne.clone().insertAfter(lastligne).removeClass('lignezero').find('input').first().datepicker();
    });

    $.datepicker.regional['fr'] = {
        closeText:       'Fermer',
        prevText:        'Précédent',
        nextText:        'Suivant',
        currentText:     'Courant',
        monthNames:      ['Janvier','Février','Mars','Avril','Mai','Juin', 'Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
        monthNamesShort: ['Jan','Fév','Mar','Avr','Mai','Jun', 'Jul','Aoû','Sep','Oct','Nov','Déc'],
        dayNames:        ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
        dayNamesShort:   ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'],
        dayNamesMin:     ['Di','Lu','Ma','Me','Je','Ve','Sa'],
        dateFormat:      'dd/mm/yy', firstDay: 1,
        isRTL: false
    };
    $.datepicker.setDefaults($.datepicker.regional['fr']);
    $.datepicker.setDefaults({
        showAnim: "slide",
        dateFormat: "dd/mm/yy"
    });
    $( ".datepicker" ).datepicker();


    $('.choisir1groupage').on( 'click', function(e) {
        e.preventDefault();
        var id_groupe = $(this).data('id');
        $.ajax({
            url: '/inc/xhr/actions_admin.php?action=deplacer&class=groupes_pages&id='+id_groupe,
            success: function(data) {
                $.popin.alert({title: "choisir une rubrique", message: data, button: "annuler"});
            }
        });
    //choisir = open("/admin/choisir_1pages.php?form_name="+mon_form_name+"&input_name="+mon_input_name+"&id_groupe="+id_groupe,"choisir","scrollbars=yes, resizable=yes, width=700, height=480");
    });

      $('.choisir_projets_docs').on( 'click', function(e) {
        e.preventDefault();
        var id_extranaute = $(this).data('id_extranaute');
        var deja_choisi = $("#projets_"+id_extranaute).val();
        $.ajax({
            url: 'inc/xhr/actions.php?action=choisir_projets_docs&id_extranaute='+id_extranaute+'&deja_choisi='+deja_choisi,
            success: function(data) {
                ouvre_popin(data);
            }
        });
    });

      $('.choisir-bandeau').on( 'click', function(e) {
        e.preventDefault();
        $.ajax({
          url: '/inc/xhr/actions_admin.php?action=choisir_bandeau',
          success: function(data) {
            $.popin.alert({title: "choisir un bandeau", message: data, button: "annuler"});
            }
          });
    });



    $('.choisir_pages_liees').on('click', function(e) {
        e.preventDefault;

        var deja = $('input[name=tab_id_page]').val()

        $.ajax({
            url: '/inc/xhr/actions_admin.php?action=set_deja_choisi&deja='+deja,
            success: function(data) {
                $.ajax({
                    url: '/inc/xhr/actions_admin.php?action=choisir_pages_liees',
                    success: function(data) {
                        $.popin.confirm({title: "choisir une ou des page(s) liée(s)", message: data, button: "Valider la sélection", callback: function(){insert_id_pages();}});
                    }
                });
            }
        });
    });


    $('.choix_date').on('change', function(e) {

      var ma_value = $(this).val(),
          input_name = $(this).attr('id');

      if(ma_value==-1) {

    $.ajax({
          url: '/inc/xhr/actions_admin.php?action=affiche_calendrier&menu_name='+input_name,
          success: function(data) {
            $.popin.alert({title: "choisir une date", message: data, button: "annuler"});
            }
          });

    //calendrier = open("/admin/inc/php/calendrier.php?etiquette="+etiquette+"&form_name="+form_name+"&menu_name="+menu_name,"calendrier","width=500, height=480");
    }
  });

    $('.choix_theme').on('change', function(e) {
      value = $(this).val(),
      champ = $(this);
      if(value==-1){
          result = prompt('saisissez votre thème', '');
          if (result != null && result != ""){
              options = champ.prop('options');
              combien = options.length;
              console.log('nb : '+combien);
              options[combien-1] = new Option(result, result, true, true);
              options[combien] = new Option('Nouveau thème...', '-1', true, false);
          }
      }
    });

    $('.choisir_pages_admin').on('change', function(e) {

      var ma_value = $(this).val(),
          input_name = $(this).attr('id');
          console.log(input_name);
      console.log('ma_value : '+ma_value);

      if(ma_value==-1) {

        var deja = $('input[name=tab_id_page]').val()

        $.ajax({
            url: '/inc/xhr/actions_admin.php?action=set_deja_choisi_admin&deja='+deja,
            success: function(data) {

              $.ajax({
                url: '/inc/xhr/actions_admin.php?action=choisir_pages_liees&droits_acces=1&input_name='+input_name,
                success: function(data) {
                    $.popin.confirm({title: "choisir une ou des page(s)", message: data, button: "Valider la sélection", callback: function(){insert_id_pages();}});
                  }
              });
            }
        });
      }
  });


  $(".get_permalien").on("change", function() {
  if($("#permalien").val() == "")
    {
    var permalien = $(this).val();
    var table = $("#formu").data("table");
    var id = $(this).data("id");
    var id_page = $('body').data("idpage");
    var comp_id = (id != '') ? '&id='+id : '';

    console.log('/inc/xhr/actions.php?action=get_new_permalien&table='+table+'&titre='+permalien+comp_id+'&id_page='+id_page);
    $.ajax({
          url: '/inc/xhr/actions.php?action=get_new_permalien&table='+table+'&titre='+permalien+comp_id+'&id_page='+id_page,
          success: function(data) {
            $("#permalientxt").html(data);
            $("#permalien").val(data);
            $("#infos_permalien").removeClass("hidden");
            }
          });
    }
  });

  $('.trouvergps').on('click', function(e){

        e.preventDefault();
        if($('input[name="adresse"]').val() != undefined) {
          var adresse=$('input[name="adresse"]').val()+' '+$('input[name="cp"]').val()+' '+$('input[name="ville"]').val();
          console.log("adresse 1 : " + adresse);
        }
        else if($('textarea[name="adresse"]').val() != undefined) {
          var adresse=$('textarea[name="adresse"]').val()+' '+$('input[name="cp"]').val()+' '+$('input[name="ville"]').val();
          console.log("adresse 2 : " + adresse);
        }
        else if($('input[name="cp"]').val() != undefined)
          var adresse=$('input[name="cp"]').val()+' '+$('input[name="ville"]').val();

        var coord = $('input[name="coordonnees_gps"]').val();


        if(coord =="") {
            var url ='https://nominatim.openstreetmap.org/search/'+adresse+'?format=json&limit=1';
            $.ajax({
                method: "GET",
                url: url,
            })
            .done(function( msg ) {
                // console.log(msg);
                if(msg.length == 0) {
                    if($('input[name="cp"]').val() != undefined)
                      var adresse=$('input[name="cp"]').val()+' '+$('input[name="ville"]').val();

                    console.log("adresse 3 : " + adresse);
                    url ='https://nominatim.openstreetmap.org/search/'+adresse+'?format=json&limit=1';
                    $.ajax({
                        method: "GET",
                        url: url,
                    })
                    .done(function( msg ) {
                        if(msg.length > 0) {
                            coord = msg[0].lat + ',' + msg[0].lon;
                        } else {
                            coord = "";
                        }
                            ouvre_carte(coord,adresse);
                    });


                } else {
                    if($('input[name="adresse"]').val() != undefined) {
                      var adresse=$('input[name="adresse"]').val()+' '+$('input[name="cp"]').val()+' '+$('input[name="ville"]').val();
                      console.log("adresse 1 : " + adresse);
                    }
                    else if($('textarea[name="adresse"]').val() != undefined) {
                      var adresse=$('textarea[name="adresse"]').val()+' '+$('input[name="cp"]').val()+' '+$('input[name="ville"]').val();
                      console.log("adresse 2 : " + adresse);
                    }
                    else if($('input[name="cp"]').val() != undefined)
                      var adresse=$('input[name="cp"]').val()+' '+$('input[name="ville"]').val();
                    console.log("adresse 4 : " + adresse);
                    coord = msg[0].lat + ',' + msg[0].lon;
                    ouvre_carte(coord,adresse);
                }
            });


        } else {
            ouvre_carte(coord,adresse);
        }
    });

    set_get_admin_page();
    setInterval('set_get_admin_page()',15000);
}); // document.ready
})(jQuery);

function ouvre_carte(coord,adresse) {
  console.log('ici : '+coord+" / "+adresse);
  $.ajax({
      url: '/inc/xhr/actions.php?action=trouver_gps&coord='+coord,
      success: function(data) {
          $.popin.confirm({title: "Récupération coordonnées gps", message: data, button: "Valider la sélection", callback: function(){selectionner();}});
          $("#popin .popinContent #search_addr").val(adresse);
        }
    });
}





function verifier_permalien(id) {
    var permalien = $("#permalien").val();
    var comp_id = (id != '') ? '&id='+id : '';
    var table = $("#formu").data("table");
    var id_parent = $("#id_parent").val();
    var id_page = $("body").data("idpage");
    var comp_parent = (id_parent != undefined) ? '&id_parent='+id_parent : '&id_page='+id_page;
    console.log(comp_parent);

    $.ajax({
          url: '/inc/xhr/actions.php?action=get_new_permalien&table='+table+'&titre='+permalien+comp_id+comp_parent,
          success: function(data) {
            $("#permalientxt").html(data);
            $("#permalien").val(data);
            $("#permalientxt").show();
            $("#lienmodifier").show();
            $("#permalienmodif").hide();
            }
          });

  }
  var permactuel = new String;
  function modifier_permalien()
  {
      permactuel = ''+$("#permalien").val();
      $("#permalientxt").hide();
      $("#lienmodifier").hide();
      $("#permalienmodif").show();
  }

function annuler_modif()
  {
            $("#permalientxt").html(permactuel);
            $("#permalien").val(permactuel);
            $("#permalientxt").show();
            $("#lienmodifier").show();
            $("#permalienmodif").hide();
  }


function set_get_admin_page() {
  var id_page = $('body').data('idpage');
  if($(".fondadmin").length==1) {
    $.ajax({
      url: '/inc/xhr/actions_admin.php?action=set_admin_page&id_page='+id_page,
      success: function(data) {
        }
    });
  }
  $.ajax({
      url: '/inc/xhr/actions_admin.php?action=get_admin_page&id_page='+id_page,
      success: function(data) {
        // console.log(data);
        $(".alertAdmin").html(data);
        }
    });
}

function maj_choix_projets(idExt) {
    var choix = "-";
    var nb_projets = 0;
    $(".choix-projets-docs input").each(function () {
        // console.log('value ' + $(this).val());
        if($(this).prop('checked')==true) {
            choix = choix + $(this).val() + '-';
            nb_projets++;
        }
    });
    choix = (choix=="-") ? "" : choix;
    $("#projets_"+idExt).val(choix);
    $("#nb_projets_"+idExt).html(nb_projets);

    // console.log('choix ' + choix);
    //alert(choix)

}

function tout_selectionner_lignes() {

    $.ajax({
        url: 'inc/xhr/actions.php?action=tout_selectionner_liste&champ_selection='+champ_selection+'&champ_liste='+champ_liste,
        success: function(nbre) {
        //alert(nbre)
        $('#montableau tbody tr').each(function () {
            fullid = $(this).attr("id");
            id = fullid.substr(5);
            if(nbre>0) {
            $('#checkbox'+id).attr("checked",true);
            $("#ligne"+id).removeClass("ligneliste");
            $("#ligne"+id).addClass("ligneselection");
            } else {
            $('#checkbox'+id).attr("checked",false);
            $("#ligne"+id).addClass("ligneliste")
            $("#ligne"+id).removeClass("ligneselection");
            }

            });

        if (nbre>1) {
            $('#checkboxtous').attr("checked",true);
            $("#ligneaction1").show();
            $("#ligneaction2").hide();
            $("#span1").html("es "+nbre);
            $("#span2").html("s");
            $("#span3").html("s");
            } else if (nbre==1) {
            $('#checkboxtous').attr("checked",true);
            $("#ligneaction1").show();
            $("#ligneaction2").hide();
            $("#span1").html("a");
            $("#span2").html("");
            $("#span3").html("");
            } else {
            $('#checkboxtous').attr("checked",false);
            $("#ligneaction1").hide();
            $("#ligneaction2").show();
            $("#span1").html("a");
            $("#span2").html("");
            $("#span3").html("");
            }

        }

      });
    }

function selectionner_ligne(id) {
    $.ajax({
        url: 'inc/xhr/actions.php?action=selection_liste&champ_selection='+champ_selection+'&valeur='+id,
        success: function(data) {
        //alert(data);
        if(data.substring(0,1)==1) {
            $("#ligne"+id).removeClass("ligneliste");
            $("#ligne"+id).addClass("ligneselection");
            }
        else {
            $("#ligne"+id).addClass("ligneliste")
            $("#ligne"+id).removeClass("ligneselection");
            }

        var nbre = data.substring(1);
        if (nbre>1) {
            $("#ligneaction1").show();
            $("#ligneaction2").hide();
            $("#span1").html("es "+nbre);
            $("#span2").html("s");
            $("#span3").html("s");
            } else if (nbre==1) {
            $("#ligneaction1").show();
            $("#ligneaction2").hide();
            $("#span1").html("a");
            $("#span2").html("");
            $("#span3").html("");
            } else {
            $("#ligneaction1").hide();
            $("#ligneaction2").show();
            $("#span1").html("a");
            $("#span2").html("");
            $("#span3").html("");
            }

        }

      });
    }


function formulaire_inscription(id){

    $(".form_inscription").html("");
    $(".form_inscription").hide();
    $.ajax({
        url: '/inc/xhr/actions.php?action=formulaire_inscription&id='+id,
        success: function(data){
            $("#form_inscription"+id).html(data);
            $("#form_inscription"+id).show();
        }
    });
}

function action_selection(i) {
    var action =    $("#actionselection"+i).val();
    if(action == "filter")
        {
            $("#selection").val(1);
            $("#rechercheList").submit();
        }

    if(action == "filter0")
        {
            $("#selection").val(0);
            $("#rechercheList").submit();
        }
    }

function choisir_projets_docs() {
        e.preventDefault();
        var id_extranaute = $(this).data('id_extranaute');
        $.ajax({
                    url: 'inc/xhr/actions.php?action=choisir_projets_docs&id_extranaute='+id_extranaute,
                    success: function(data) {
                        ouvre_popin(data);
                        }
                    });
}

function aujourdhui(form,champ,format)
    {
    if( format == 'fr' )
        {
        $("#"+form+" #"+champ).val(today_fr);
        document.forms[form].elements[champ].value = today_fr;
        document.forms[form].elements[champ].focus();
        }
    else
        {
        $("#"+form+" #"+champ).val(today_us);
        document.forms[form].elements[champ].value = today_us;
        document.forms[form].elements[champ].focus();
        }

    }

function alert_supp_gourl(monurl,moncomplement_alerte)
    {
    if(confirm("Etes-vous certain de vouloir supprimer définitivement " + moncomplement_alerte + " ?"))
        {
            window.location.href = monurl;
        }
    }

function alert_supp(monurl,maclass,monaction_id,moncomplement_alerte)
    {
    if(confirm("Etes-vous certain de vouloir supprimer définitivement " + moncomplement_alerte + " ?"))
        {
            window.location.href = monurl+"&action=supprimer&class="+maclass+"&action_id="+monaction_id;
        }
    }

function alert_supp_icd1(rubrique_id,id)
    {

    if(confirm("Etes-vous certain de vouloir supprimer cette information pour cette page uniquement ? "))
        {
            window.location.href = racine+"?rubrique_id="+rubrique_id+"&action=purger_col_infos&fonction_id="+rubrique_id+"&class=col_infos&action_id="+id;
        }
    }

function alert_supp_icd2(rubrique_id,id,comp)
    {
    alert_comp = (comp>0) ? " sur les " + comp + " pages où elle est présentée ?" : " ?";

    if(confirm("Etes-vous certain de vouloir supprimer définitivement cette information"+alert_comp))
        {
            window.location.href=racine+"?rubrique_id="+rubrique_id+"&action=supprimer&class=col_infos&action_id="+id;
        }
    }






function deplacer(ma_class,mon_id)
    {
    var type_choix = (ma_class == "groupes_pages") ? " une rubrique" : " une page";
    $.ajax({
          url: '/inc/xhr/actions_admin.php?action=deplacer&class='+ma_class+'&id='+mon_id,
          success: function(data) {
            $.popin.alert({title: "choisir"+type_choix, message: data, button: "annuler"});
            }
          });
        //choisir = open("/admin/deplacer_page.php?class="+ma_class+"&id="+mon_id,"choisir","scrollbars=yes, resizable=yes, width=700, height=480");
    }

function lien_direct_page()
    {
    $.ajax({
          url: '/inc/xhr/actions_admin.php?action=deplacer&class=groupes_pages&id=0',
          success: function(data) {
            $.popin.alert({title: "choisir une page", message: data, button: "annuler"});
            }
          });
//      choisir = open("/admin/deplacer_page.php","choisir","scrollbars=yes, resizable=yes, width=700, height=480");
    }

function test_modifier_pages(value,input_name,form_name,la_class,le_id,le_enfant)
    {

    $.ajax({
          url: '/inc/xhr/actions_admin.php?action=choisir_pages&form_name='+form_name+'&input_name='+input_name+'&la_class='+la_class+'&le_id='+le_id+'&le_enfant='+le_enfant,
          success: function(data) {
            $.popin.alert({title: "choisir une page", message: data, button: "annuler"});
            }
          });

        //choisir = open("/admin/choisir_pages.php?form_name="+form_name+"&input_name="+input_name+"&la_class="+la_class+"&le_id="+le_id+"&le_enfant="+le_enfant,"choisir","scrollbars=yes, resizable=yes, width=700, height=480");
    }

function test_ajouter_pages(value,input_name,form_name,la_class,le_id,le_enfant)
    {
        choisir = open("/admin/choisir_pages.php?form_name="+form_name+"&input_name="+input_name+"&la_class="+la_class+"&ajouter="+le_id+"&le_enfant="+le_enfant+"&type=0","choisir","scrollbars=yes, resizable=yes, width=700, height=480");
    }

function goto_url(url)  {
    window.location.href=url;
    }

function color_ligne( ligne, OnOff ) {
    if ( OnOff ) {
        ligne.style.backgroundColor = '#ECECE9';
    } else {
        ligne.style.backgroundColor = '#FFFFFF';
    }
}

function ouvre_ferme(i){
    var div=document.getElementById("tab"+i);
    var display = (div.style.display=='none') ? 'block' : 'none';
    //alert(display);
    $.ajax({
        url: '../inc/xhr/actions.php?action=save_session&name_session=tab'+i,
        success: function(data) {
            div.style.display = display;
            // console.log("tab"+i+" > "+data);
        }
    });
}

function test_nouveau_item(value,menu_name,form_name,message,etiquette){
    if(value==-1){
        result = prompt(message, '');
        if (result != null && result != ""){
            combien = document.forms[form_name].elements[menu_name].length;
            nouveau = new Option(etiquette,-1,false,false);
            ajout = new Option(result,result,true,true);
            document.forms[form_name].elements[menu_name].options[combien] = nouveau;
            document.forms[form_name].elements[menu_name].options[combien-1] = ajout;
        }
    }
}

function quelle_operateur(field_name,form_name)
    {
    chercher = open("/admin/choisir_operateur.php?form_name="+form_name+"&field_name="+field_name,"chercher","width=500, height=480,scrollbars=yes,resizable=yes");
    }



function MM_openBrWindow(theURL,winName,features){ //v2.0
  window.open(theURL,winName,features);
}


function MM_jumpMenu(targ,selObj,restore){ //v3.0
  eval(targ+".location='"+selObj.options[selObj.selectedIndex].value+"'");
  if (restore) selObj.selectedIndex=0;
}


function ouvre_ferme_menu(i){
    var divo=document.getElementById("menu"+i+"ouvert");
    var divf=document.getElementById("menu"+i+"ferme");

    if (divo.style.display=='none'){
        divo.style.display='block';
        divf.style.display='none';
    }
    else{
        divo.style.display='none';
        divf.style.display='block';
    }
}

function affiche_1div(num,nbre,div_prefixe){
    for(i=1;i<=nbre;i++){
        if (i==num) {
            //alert("#"+div_prefixe+i);
            $("#"+div_prefixe+i).css("display",'block');
        }
        else
            $("#"+div_prefixe+i).css("display",'none');
    }
}